'use strict';

const eventDateHelper = require('../components/eventDateHelper');
const inputDateHelper = require('../components/inputDateHelper');

const SELECTORS = {
    datepicker: '.js-datepicker',
    submitBtn: '.js-datepicker-submit',
    submitBtnPlp: '.js-datepicker-submit-plp',
    resetBtn: '.js-datepicker-reset',
    dateDropdown: '.js-datepicker-date-dropdown',
    activeDateDropdown: '.js-datepicker-date-dropdown.active',
    dropdownDate: '.js-dropdown-date',
    eventDateForm: '.js-event-date-form',
    datepickerInput: '.js-input-date'
}

// Init Datepicker
initDatePicker();

function getSelectedDate() {
    let date = null;
    if ($(SELECTORS.dropdownDate).length) {
       date = $(SELECTORS.dropdownDate).data('date');
    }

    return date;
}

// Submit Date PLP
$(SELECTORS.submitBtnPlp).on('click', function () {
    const selectedDate = $(`#${$(this).attr('data-id')}`).datepicker('getDate');

    $.spinner().start();

    if ($(SELECTORS.dropdownDate).length) {
        $(SELECTORS.dropdownDate).text($.datepicker.formatDate('mm/dd/yy', selectedDate));
    }

    $(SELECTORS.datepicker).datepicker('hide');
    $(SELECTORS.dateDropdown).removeClass('active');

    eventDateHelper.setDate($(this).data('url'), selectedDate);
});

// Submit Date (General)
$('body').on('click', SELECTORS.submitBtn, function (e) {
    e.preventDefault();
    var $dateInput = $(this).closest('form').find(SELECTORS.datepickerInput).first();
    if (!$dateInput.length) {
        $dateInput = $(SELECTORS.datepickerInput).first();
    }
    var selectedDate = inputDateHelper.getDate($dateInput);

    $.spinner().start();

    eventDateHelper.setDate($(SELECTORS.eventDateForm).attr('action'), selectedDate);
});

// Reset Date
$(SELECTORS.resetBtn).on('click', function () {
    eventDateHelper.setDate($(SELECTORS.submitBtnPlp).data('url'), null);
});

// Init Datepicker
function initDatePicker() {
    $(SELECTORS.datepicker).each(function () {
        let $datepicker = $(this);

        const params = {
            minDate: SitePreferences.ORDER_THRESHOLD,
            nextText: 'Next Month',
            prevText: 'Previous Month',
            onUpdateDatepicker: function() {
                // Accessibility: Add href to prev/next anchors so that they can receive TAB focus
                $('.ui-datepicker-prev, .ui-datepicker-next')
                    .not('.ui-state-disabled')
                    .attr('href', '#')
                    .trigger('focus');
            },
            onChangeMonthYear: function() {
                // Accessibility: Focus to the available button inside the calendar.
                $(SELECTORS.activeDateDropdown).find('button').first().trigger('focus');
            }
        }

        let selectedDate = getSelectedDate();
        if (selectedDate) {
            params.defaultDate = selectedDate;
        }

        $datepicker.datepicker(params);
    });
}

module.exports = {
    reInit: function() {
        $(SELECTORS.datepicker).each(function () {
            let $datepicker = $(this);
            $datepicker.datepicker('destroy');
        });

        initDatePicker();
    }
};